<template>
    <div
        id="portal-screen-pop"
        class="fixed inset-0 flex flex-col items-center justify-end px-4 py-6 pointer-events-none z-40 space-y-4 | md:p-6"
    />
</template>
